<template>
  <section class="mobility">
    <mobility-hero />
    <mobility-slider />
    <mobility-offers />

    <mobility-rent />
    <mobility-alt-image-text />
    <mobility-testimonials />
    <button-back-to-top />
  </section>
</template>
<script>


export default {
  name: 'MobilityLayout',
  components: {
    MobilityOffers: () => import(/* webpackChunkName: "home"  */ `./MobilityOffers`),
    MobilityRent: () => import(/* webpackChunkName: "home"  */ `./MobilityRent`),
    MobilityAltImageText: () => import(/* webpackChunkName: "home"  */ `./MobilityAltImageText`),
    MobilityTestimonials: () => import(/* webpackChunkName: "home"  */ `./MobilityTestimonials`),
    ButtonBackToTop: () => import(/* webpackChunkName: "home"  */ `../shared/ButtonBackToTop`),
    MobilityHero: () => import(/* webpackChunkName: "home"  */ `./MobilityHero`),
    MobilitySlider: () => import(/* webpackChunkName: "home"  */ `./MobilitySlider`),
  },
  data() {
    return {
      scrollPosition: null,
    }
  },
  computed: {
    showHeader() {
      return this.$store.state.stepping.header
    },
  },
}
</script>

<style lang="scss" scoped>
section ::v-deep .toto {
  color: red;
}
</style>
